// 要求：
// 对同一个请求可能每次请求的参数不同，我需要针对不同的参数缓存不同的结果
// 我的缓存必须保证新鲜度，如果缓存时间过久需要重新请求
// 如果第一次请求失败，我不应该将失败的结果缓存下来
// 在某些情况下我想主动清除缓存

const isEqual = require('lodash.isequal')

class CachePromise {
  constructor () {
    this.store = {}

    this.callIndex = null
    this.callKey = null
    this.fn = null
    this.parameter = null
    this.currentCallTime = null
  }

  _isPromise (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function'
  }

  _getData ({ parameter, callTime }) {
    let storeItem = {}

    if (!Array.isArray(this.store[this.callKey])) this.store[this.callKey] = []

    storeItem['isRequesting'] = true
    storeItem['parameter'] = parameter
    storeItem['createTime'] = callTime
    storeItem['promise'] = new Promise((resolve, reject) => {
      this.fn(this.parameter)
        .then((data) => {
          resolve(data)
          storeItem['isRequesting'] = false
          storeItem['callStatus'] = true
          // console.log('获取成功，加入缓存, 打印store', this.store)
        })
        .catch((err) => {
          // console.log('获取失败')
          storeItem['isRequesting'] = false
          storeItem['callStatus'] = false
          reject(err)
        })
    })

    this.store[this.callKey].push(storeItem)
    return storeItem['promise']
  }

  _cacheData () {
    // console.log('使用缓存')
    // console.log(this.store[this.callKey][this.callIndex].promise)
    return this.store[this.callKey][this.callIndex].promise || null
  }

  _clearData () {
    this.store[this.callKey].splice(this.callIndex, 1)
  }

  cache ({ fn, parameter = null, maxAge = 5000 }) {
    // console.log('刚进入cache函数，打印store', this.store)

    // 检测前置条件
    if (typeof fn !== 'function') throw new Error('fn should be a function')
    if (!fn.name) throw new Error('fn should be a Named function')

    // 赋值
    this.callKey = fn.name
    this.fn = fn
    this.parameter = parameter
    this.currentCallTime = Date.now()

    // 检测库中是否有对应的 function
    if (!(this.callKey in this.store)) return this._getData({ parameter: this.parameter, callTime: this.currentCallTime })
    // 取出对应的数据
    let callList = this.store[this.callKey]
    let callInfo = null

    for (var i = callList.length - 1; i > -1; i--) {
      let item = callList[i]
      if (item.parameter && isEqual(item.parameter, parameter)) {
        this.callIndex = i
        callInfo = item
        break
      }
    }

    // 检测上一次请求是否完成
    if (callInfo && callInfo.isRequesting) {
      return new Promise((resolve, reject) => {
        reject(new Error('Requesting, please wait...'))
      })
    }

    // 检测状态
    if (callInfo && !callInfo.callStatus) {
      this._clearData()
      return this._getData({ parameter: this.parameter, callTime: this.currentCallTime })
    }

    if (callInfo && callInfo.createTime && (this.currentCallTime - callInfo.createTime < maxAge) && callInfo.promise && this._isPromise(callInfo.promise)) return this._cacheData()

    if (callInfo) this._clearData()
    return this._getData({ parameter: this.parameter, callTime: this.currentCallTime })
  }
}

export default new CachePromise()
